export const onboardingStatusChangedEvent = 'neatolabs:onboarding-status-changed'

export const notifyOnboardingStatusChanged = () => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(onboardingStatusChangedEvent))
}

